import * as React from 'react';
import * as moment from 'moment';
import { ListDayProps } from '../../components/list/day';
import ListEvent from '../../components/list/event';


const GridDayView: React.StatelessComponent<ListDayProps> = props => {
    const dateMoment = moment(props.day.date);
    const todayMoment = moment();
    const isDayInPast = dateMoment.isBefore(todayMoment, 'day');

    return (
        <li className={`ace-cal-list-day ${isDayInPast ? "ace-cal-list-day-hide" : ""} ${props.day.events.length > 0 ? "" : " ace-cal-list-day-hide"}`} aria-labelledby={`List-Day-${dateMoment.format("X")}`}>
            <h4 className="ace-cal-list-day-date">{dateMoment.format("dddd, MMMM D")}</h4>
            <ul className="ace-cal-list-day-content">
                {
                    props.day.events.map(event => <ListEvent key={event.id} event={event} />)
                }
            </ul>
        </li>
    );
}

export default GridDayView; 